import { useNavigate } from "@tanstack/react-router";
import { Clock } from "lucide-react";
import {
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export function InvitationExpiredCard({
  organizationName,
}: {
  organizationName: string;
}) {
  const navigate = useNavigate();

  return (
    <>
      <CardHeader className="items-center text-center">
        <div className="rounded-full bg-amber-100 p-3 mb-2">
          <Clock className="h-6 w-6 text-amber-600" />
        </div>
        <CardTitle className="text-xl">Invitation expired</CardTitle>
        <CardDescription>
          This invitation has expired. Ask {organizationName} to resend it.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Button
          variant="outline"
          className="w-full"
          onClick={() => navigate({ to: "/" })}
        >
          Go to Saile
        </Button>
      </CardContent>
    </>
  );
}
